import { YStack, Text } from "tamagui";

const Postscript = () => {
  return (
    <YStack bg="$blue2" p="$4" br="$4" ai="center" jc="center">
      <Text fontSize="$4" color="black">
        <Text> 🕐 營業時間：</Text>
        週一至週六 09:00-18:00
      </Text>
    </YStack>
  );
};

export default Postscript;
